import { appConfig } from '../../../../../../../config/customization';

const iconSize = 55;
const SQUARE_SIZE = 145;

const squareButtonStyle = {
  height: SQUARE_SIZE,
  width: SQUARE_SIZE,
  borderRadius: 20,
  boxShadow: `3px 3px 5px 0px ${appConfig.colors.gray}`,
  ':active': {
    boxShadow: 'none'
  }
};

export default {
  square0: {
    ...squareButtonStyle,
    backgroundColor: appConfig.colors.squaredButton1
  },
  square1: {
    ...squareButtonStyle,
    backgroundColor: appConfig.colors.squaredButton2
  },
  square2: {
    ...squareButtonStyle,
    backgroundColor: appConfig.colors.squaredButton3
  },
  square3: {
    ...squareButtonStyle,
    backgroundColor: appConfig.colors.squaredButton4
  },
  square4: {
    ...squareButtonStyle,
    backgroundColor: appConfig.colors.squaredButton5
  },
  square5: {
    ...squareButtonStyle,
    backgroundColor: appConfig.colors.squaredButton6
  },
  iconContainer: {
    height: iconSize,
    width: iconSize,
    backgroundColor: appConfig.colors.white,
    borderRadius: '50%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  },
  icon: {
    height: 30
  },
  content: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
    width: '100%'
  },
  description: {
    lineHeight: '15px',
    paddingTop: '3px',
    whiteSpace: 'normal',
    display: 'block'
  },
  category: {
    width: '100%'
  }
};
